module.exports = __webpack_public_path__ + "75d6e710b49fdfafea70930eacf3b533.pdf";